import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('recap');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);

      const offset = 140;
      let current = navLinks[0].id;
      navLinks.forEach((link) => {
        const el = document.getElementById(link.id);
        if (el && el.getBoundingClientRect().top - offset <= 0) {
          current = link.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 max-w-content items-center justify-between px-4 md:px-6">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            handleNav('hero');
          }}
          className="flex items-center gap-2 cursor-pointer"
          aria-label="51.吃瓜 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-label text-sm font-bold text-background-50">
            51
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              吃瓜
            </span>
            <span className="font-label text-[10px] tracking-[0.25em] text-primary-600">
              CATCH UP
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNav(link.id);
              }}
              className={`whitespace-nowrap rounded-full px-3 py-2 font-label text-sm transition-colors cursor-pointer ${
                active === link.id
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#trending"
            onClick={(e) => {
              e.preventDefault();
              handleNav('trending');
            }}
            className="hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-fire-line" />
            </span>
            热门吃瓜
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/80 bg-background-50 px-4 pb-5 pt-3">
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.id);
                }}
                className={`whitespace-nowrap rounded-md px-3 py-3 text-center font-label text-sm transition-colors cursor-pointer ${
                  active === link.id
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-background-100 text-foreground-700'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}